<template>
  <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2">라이선스 복호화</h1>
  </div>    
  <SelectButton v-model="selectedOption" :options="options" optionDisabled="constant" optionLabel="name" aria-labelledby="basic" @update:modelValue="reset" />      
  <Chip v-if="selectedOption && selectedOption.value === 'MirrorLink'" label="InitLicenseData.hcinsdata 파일내에 값을 넣어주세요..." icon="pi pi-megaphone" style="margin-left: 15px;margin-top: 20px;" />  
  <div v-if="selectedOption" class="flex-container">     
    <span class="p-float-label">
    <InputText v-if="isMobile==false" id="username" v-model="encodedLicenseKey" style="width: 300px;" />
    <Textarea v-if="isMobile==true" id="username" v-model="encodedLicenseKey" autoResize rows="4" :style="{ 'font-family': 'Consolas,monaco,monospace' ,'min-width': '300px'  }"/>
    <label for="username">License Key</label>
    </span>    
    <Button @click="runDecode" icon="pi pi-arrow-right-arrow-left" style="color: white;background-color: #3B82F6; margin-left: 5px;margin-right: 5px;" />
  </div>
  <br><br>
  <div v-if="selectedOption && selectedOption.value === 'REPORT6' && decodeError" style="color:red; margin-top:10px; font-weight:bold;">
    {{ decodeError }}
  </div>
  <template v-if="selectedOption && selectedOption.value === 'REPORT6' && decodedLicense.companyName">
  <table>
    <tr>
        <th scope="row">서명 상태</th>
        <td :style="{ color: decodedLicense.version && decodedLicense.version.startsWith('✔') ? 'green' : 'orange', fontWeight: 'bold' }">{{ decodedLicense.version }}</td>
    </tr>
    <tr>
        <th scope="row">고객사</th>
        <td>{{ decodedLicense.companyName }}</td>
    </tr>
    <tr>
        <th scope="row">프로젝트</th>
        <td>{{ decodedLicense.projectName }}</td>
    </tr>
    <tr>
        <th scope="row">CPU 코어</th>
        <td>{{ decodedLicense.cpu }}</td>
    </tr>
    <tr>
        <th scope="row">허용 IP</th>
        <td>{{ decodedLicense.ip }}</td>
    </tr>
    <tr v-if="decodedLicense.hostName">
        <th scope="row">호스트명</th>
        <td>{{ decodedLicense.hostName }}</td>
    </tr>
    <tr>
        <th scope="row">효력일</th>
        <td>{{ decodedLicense.sdate }}</td>
    </tr>
    <tr>
        <th scope="row">만료일</th>
        <td>{{ decodedLicense.edate }}</td>
    </tr>
    <tr>
        <th scope="row">활성 기능</th>
        <td>{{ decodedLicense.products }}</td>
    </tr>
  </table>
  <br>
  <div style="font-weight:bold; margin-bottom:6px;">원본 JSON (signatureBase64 포함)</div>
  <Textarea :value="encodedLicenseKey" autoResize rows="6" disabled :style="{ 'font-family': 'Consolas,monaco,monospace', 'min-width': '100%', 'font-size': '12px' }" />
  </template>
  <template v-else-if="selectedOption && selectedOption.value === 'REPORT6'"></template>
  <table  v-if="selectedOption && selectedOption.value === 'V3'">
  	<tr>
        <th scope="row">고객사</th>
        <td>{{ decodedLicense.companyName }}</td>
    </tr>
    <tr>
        <th scope="row">프로젝트</th>
        <td>{{ decodedLicense.projectName }}</td>
    </tr>
    <tr>
        <th scope="row">인증번호</th>
        <td>{{ decodedLicense.licenseSeq }}</td>
    </tr>
	  <tr>
        <th scope="row">ip</th>
        <td>{{ decodedLicense.ip }}</td>
    </tr>
    <tr>
        <th scope="row">cpu core</th>
        <td>{{ decodedLicense.cpu }}</td>
    </tr>   
    <tr>
        <th scope="row">호스트명</th>
        <td>{{ decodedLicense.hostName }}</td>
    </tr>  
    <tr>
        <th scope="row">시작일</th>
        <td>{{ decodedLicense.sdate }}</td>
    </tr>
    <tr>
        <th scope="row">만료일</th>
        <td>{{ decodedLicense.edate }}</td>
    </tr>        
    <tr>
        <th scope="row">모듈버젼</th>
        <td>{{ decodedLicense.products }}</td>
    </tr>
  </table>
  <table v-else-if="selectedOption && selectedOption.value === 'MirrorLink'">
    <tr>
        <th scope="row">고객사</th>
        <td>{{ decodedLicense.companyName }}</td>
    </tr>
    <tr>
        <th scope="row">프로젝트</th>
        <td>{{ decodedLicense.projectName }}</td>
    </tr>
    <tr>
        <th scope="row">인증번호</th>
        <td>{{ decodedLicense.licenseSeq }}</td>
    </tr>
    <tr>
        <th scope="row">서버구분</th>
        <td>{{ decodedLicense.serverType }}</td>
    </tr>
    <!--
	  <tr>
        <th scope="row">ip</th>
        <td>{{ decodedLicense.ip }}</td>
    </tr>
    <tr>
        <th scope="row">cpu core</th>
        <td>{{ decodedLicense.cpu }}</td>
    </tr>   
    <tr>
        <th scope="row">호스트명</th>
        <td>{{ decodedLicense.hostName }}</td>
    </tr>  
    -->
    <tr>
        <th scope="row">시작일</th>
        <td>{{ decodedLicense.sdate }}</td>
    </tr>
    <tr>
        <th scope="row">만료일</th>
        <td>{{ decodedLicense.edate }}</td>
    </tr>        
    <tr>
        <th scope="row">모듈버젼</th>
        <td>{{ decodedLicense.products }}</td>
    </tr>
    <tr>
        <th scope="row">UUID</th>
        <td>{{ decodedLicense.uuid }}</td>
    </tr>
    <tr>
        <th scope="row">Version</th>
        <td>{{ decodedLicense.version }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'LicenseMain',
  data() {
    return {      
      isMobile : this.$isMobile(),
      encodedLicenseKey : '',
      decodedLicense: {},
      decodeError: '',      
      selectedOption: { name: '리포트/이폼', value: 'V3', constant: false },    
      options: [
                { name: '리포트/이폼', value: 'V3', constant: false },
                { name: '클립리포트/이폼 6.0', value: 'REPORT6', constant: false },
                { name: 'MirrorLink', value: 'MirrorLink', constant: false }
            ],
    };
  },  
  components: {    
  },
  created() {  	
  },
  mounted(){
    this.onResize();
    window.addEventListener('resize',this.onResize,{passive:true});
  },
  beforeDestory(){
    if(typeof window === 'undefined') return;
    window.removeEventListener('resize',this.onResize,{passive:true});
  },
  methods: {
  	onResize(){
      this.isMobile = window.innerWidth < 600      
    },
    runDecode(){
      if(this.encodedLicenseKey != undefined){
        this.decodeError = '';
        if (this.selectedOption.value === 'REPORT6') {
          var param = {
            encodedLicenseKey: this.encodedLicenseKey.trim(),
            licenseVersion: 'REPORT6',
          };
          this.$post('/biz/license/decode', param,
            function(response, i){
              var result = response.data.decodeResult;
              var errNames = ['라이선스 파싱 오류', '서명 검증 실패', '라이선스 오류'];
              if (errNames.indexOf(result.companyName) !== -1) {
                i.decodeError = result.companyName;
                i.decodedLicense = {};
              } else {
                i.decodedLicense = result;
              }
            },
            function(e, i){ console.log(e); }
          );
        } else {
          var encodedLicenseKey = this.encodedLicenseKey.replace(/ /g, '');
          const s = encodedLicenseKey.trim();
          try {
            if(s.startsWith('{') || s.startsWith('[')){
              encodedLicenseKey = JSON.parse(encodedLicenseKey).data;
            }
          } catch (e) {
            console.log(e);
          }
          var paramGet = {
            encodedLicenseKey: encodedLicenseKey,
            licenseVersion: this.selectedOption.value,
          };
          this.$get('/biz/license/decode', { params: paramGet },
            function(response, i){
              i.decodedLicense = response.data.decodeResult;
            },
            function(e, i){ console.log(e); }
          );
        }
      }
    },
    reset(){
      this.encodedLicenseKey ='';
      this.decodedLicense={};
      this.decodeError='';
    }
  },
  
};
</script>

<style scoped>
/* 추가적인 스타일링이 필요하다면 여기에 추가하세요. */
.table-container {
  width: 100%;
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

th, td {
  padding: 12px;  
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

th {
  background-color: #f2f2f2;
  width:100px;
  text-align: center;
}

/* 헤더를 위로 이동시키기 위한 스타일 */
thead th {
  height: 0;
  line-height: 0;
}

tbody td:first-child, thead th:first-child {
  padding-left: 0;
}

tbody td, thead th {
  border-left: 1px solid #ddd;
}
.flex-container {
  display: flex;
  align-items: center; /* 요소들을 세로 중앙에 정렬합니다. */
  margin-Top: 30px;
}
</style>
